/**
 * ------------------------------------------------------------------------------------------------------------
 * ARCHITECTURAL NOTE:
 * KHÔNG sử dụng file index.ts (Barrel) trong thư mục @core để tránh Circular Dependency (NG0200).
 * Luôn import trực tiếp từ file nguồn.
 * ------------------------------------------------------------------------------------------------------------
 */
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";


@Injectable({
  providedIn: 'root'
})
export class CookiePosService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
  }

  setCookie(name: string, value: string, days?: number): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null; // Không có document.cookie trên SSR
    }

    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  deleteCookie(name: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return; // Không có document.cookie trên SSR
    }

    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  getAllCookies(): { [key: string]: string } {
    if (!isPlatformBrowser(this.platformId)) {
      return {}; // Không có document.cookie trên SSR
    }

    const pairs = document.cookie.split(';');
    const cookies: { [key: string]: string } = {};
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      cookies[(pair[0] + '').trim()] = unescape(pair.slice(1).join('='));
    }
    return cookies;
  }

  hasCookie(name: string): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false; // Không thể kiểm tra trên SSR
    }

    return this.getCookie(name) !== null;
  }
}
